import { MultiSelect } from "react-multi-select-component";
import styled from "styled-components";

const StyledMultiSelect = styled(MultiSelect)`
    & .dropdown-container {
        height: 48px;
        border: 1px solid;
        > :hover {
            border: 1px solid #9654ff;
        }
    }
    & .dropdown-heading {
        height: 100%;
    }
`;

const StyledLabel = styled.p`
    font-size: 13px;
    line-height: 120%;
    color: #787878;
    margin: 0 32px 0 0;
`;

export default {
    StyledMultiSelect,
    StyledLabel,
};
